export function readJsonConfig<T>(id: string): T | null {
	const el = document.getElementById(id);
	if (!el) return null;
	try {
		return JSON.parse(el.textContent || "") as T;
	} catch {
		return null;
	}
}